module.exports = __webpack_public_path__ + "static/media/blog1.ebe621ac.png";